import { render, staticRenderFns } from "./certiticateProHireXpList.vue?vue&type=template&id=dc965e8a&scoped=true&"
import script from "./certiticateProHireXpList.vue?vue&type=script&lang=js&"
export * from "./certiticateProHireXpList.vue?vue&type=script&lang=js&"
import style0 from "./certiticateProHireXpList.vue?vue&type=style&index=0&id=dc965e8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc965e8a",
  null
  
)

export default component.exports